import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface UsersOnline {
    members: Array<string>;
}

export const initialState: UsersOnline = {
    members: []
};

const usersOnlineFeatureSelector = createFeatureSelector('users_online');

export const usersOnlineSelector = createSelector(
    usersOnlineFeatureSelector,
    (state: UsersOnline) => state
);

export const usersOnlineMembersSelector = createSelector(
    usersOnlineFeatureSelector,
    (state: UsersOnline) => state.members
);
